export default String.raw`

{% capture cartPath -%} 'elements/cart/{{settings.cartId}}.html' {% endcapture -%}
{% include cartPath -%}

`